import { render, staticRenderFns } from "./HeadChild.vue?vue&type=template&id=4a63843a&scoped=true&"
import script from "./HeadChild.vue?vue&type=script&lang=js&"
export * from "./HeadChild.vue?vue&type=script&lang=js&"
import style0 from "./HeadChild.vue?vue&type=style&index=0&id=4a63843a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63843a",
  null
  
)

export default component.exports